import classNames from 'classnames'

import ErrorLabel from './ErrorLabel'
import styles from './InputWithLabel.module.scss'

function Textarea({
  value,
  id,
  onChange,
  placeholder,
  rows,
  maxLength,
  hasError,
  errorText,
}) {
  return (
    <div className={styles.textAreaContainer}>
      <textarea
        id={id}
        name={id}
        className={classNames(styles.input, { [styles.errorState]: hasError })}
        rows={rows}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        // maxLength={maxLength}
      />
      <div
        className={classNames(styles.charCountContainer, {
          [styles.errorText]: hasError,
        })}
      >
        {hasError && <ErrorLabel errorText={errorText} />}
        <div>
          <span id="current">{value.length}</span>
          <span id="maximum">/ {maxLength}</span>
        </div>
      </div>
    </div>
  )
}

export default Textarea
